
import Vue from 'vue';
import { mapState } from 'vuex';

import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import Icon from '@root/modules/weather/components/Icon.vue';
import { weatherIconParser } from '@root/modules/weather/utils/weatherParser';
import { ListData } from '@root/modules/navigation/types/navigation';

interface Computed {
  weather: Record<string, any> | null;
  temperature: string | null;
  icon: string | null;
}

interface Methods {
  weatherIconParser: typeof weatherIconParser;
}

interface Props {
  link: ListData;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  name: 'WeatherIcon',
  components: {
    LinkHandler,
    Icon,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      weather: (state: any) => state.navigation.weather,
    }),
    temperature() {
      let temperature = null;

      if (this.weather) {
        temperature = this.weather.currentWeather.data.instant.details.air_temperature.toFixed(0);
      }

      return temperature;
    },
    icon() {
      let icon = null;

      if (this.weather) {
        icon = this.weather.currentWeather.data.next_1_hours.summary.symbol_code;
      }

      return icon;
    },
  },
  methods: {
    weatherIconParser,
  },
});
